
const domainRegex = /^([a-zA-Z0-9][a-zA-Z0-9-_]*\.)*[a-zA-Z0-9]*[a-zA-Z0-9-_]*[[a-zA-Z0-9]+$/

export function checkInput(scr,val,blur){
    if(scr){
        if(val){
            return 'good'
        }else{
            if(blur){
                return 'error'
            }
        }
    }
    return '';
} 

export function checkDomain(sub){
    if(sub){
        const d = sub + '.mydomain.com'
        console.log(d);
        console.log(domainRegex.exec(d));
        if(domainRegex.exec(d)){
            return true;
        }
    }
    return false;
} 
//[a-zA-Z0-9][a-zA-Z0-9-_]

function LoaderShow(){
    console.log('show loader');
}
function LoaderHide(){
    console.log('hide loader');
}

function getQueryData(data){
    const esc = encodeURIComponent;
    return Object.keys(data)
    .map(k => esc(k) + '=' + esc(data[k]))
    .join('&');
}

export function handleLogin(api,path,obj,email,password,submitted,result,token){
    const data = {subdomain:obj.sub,zone:obj.domain,Email:email,Password:password,__RequestVerificationToken:token};
    console.log(data);

    fetch(api + path,{
        method: 'post',
        headers: {
            
           // 'cache-control': 'no-cache',
            'Accept': 'application/json',
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: getQueryData(data)//JSON.stringify(data)
    }).then(res=> res.json()).then(json=>{
        if(json){
            if(json.result){
                //redirect to checkout
                toCheckout(api,{subdomain:obj.sub,zone:obj.domain,userguid:json.userguid,planid:obj.plan.id,__RequestVerificationToken:token});
            }else{
                if(path === "Domains/UserLogin")    {
                    document.getElementById("check-login").style.visibility = "visible"
                    console.log('login issue');
                }else{
                    document.getElementById("check-reg").style.visibility = "visible"
                    console.log('register issue');
                }
         
            }
        }
    })
    .catch(err=>{
        result = false;
    })
    submitted = true;
}


export function handleForgot(api,path,email,submitted,result,token){
    const data = {Email:email,__RequestVerificationToken:token};
    console.log(data);

    fetch(api + path,{
        method: 'post',
        headers: {
            'Accept': 'application/json',
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: getQueryData(data)
    }).then(res=> res.json()).then(json=>{
        console.log(json);
        if(json){
            if(json.result){
                result = true;
                document.getElementById("check-email").style.visibility = "visible";
                console.log('reset email sent');

            }
        }
    })
    .catch(err=>{
        result = false;
        console.log(err);
    })
    submitted = true;
}

function toCheckout(api,body){

    // const stripe = Stripe('pk_test_WTQGG1zEM2vOhGA1Yvo7yvLa')
    const stripe = Stripe('pk_live_CLWHhJAjlWUtcuvfK2b1GuVI')


    console.log('start stripe checkout')
    LoaderShow();
    fetch(api+"Domains/ToCheckout",{
        method: 'post',
        headers: {
           
           // 'cache-control': 'no-cache',
            'Accept': 'application/json',
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body:getQueryData(body)
    }).then(res => res.json()).then(json => {

        console.log(json);

        if (json) {
            stripe.redirectToCheckout({
                sessionId: json.id
            }).then(function (result) {

                if (result.error) {
                    console.log(result.error.message);
                    LoaderHide();
                }

            });
        } else {
            LoaderHide();
        }
    }).catch(err => {
        console.log(err);
        LoaderHide();
    })

}